import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContentContext";

export const DialogHeader = ({ className, ...props }: ComponentProps<"div">) => {
  const { divided } = useDialogContentContext();
  return (
    <div
      data-slot="dialog-header"
      className={cn(
        "flex flex-col gap-2 text-center sm:text-left",
        divided && "px-6 py-4 [&:not(:first-child)]:border-t",
        className
      )}
      {...props}
    />
  );
};
